import { CurrentMoment } from '../../CurrentMoment';
import type { ColorPalette } from '../../ColorPalette';
import { AbstractScheduleEvent } from './AbstractScheduleEvent';

/**
 * One-off date + time schedule event (anchor: date).
 */
export class DateScheduleEvent extends AbstractScheduleEvent {
	constructor(
		private readonly datetime: Date,
		colorPalette: ColorPalette
	) {
		super(colorPalette);
	}

	getLatestScheduleEvent(): Date {
		return CurrentMoment.lastDateScheduleAt(this.datetime);
	}

	getNextBoundaryAfter(): number | null {
		return CurrentMoment.nextDateBoundaryMs(this.datetime);
	}
}
